/* eslint-disable jsx-a11y/anchor-is-valid */

import { useState } from "react"
import { Link } from "react-router-dom"
import ScheduleVisit from "./ScheduleVisit"
import SaveFeedback from "./SaveFeedback"
import { leadPropertyStatus } from "../LeadManagementAPI"
import Swal from "sweetalert2"

const ViewLeadStep2 = (
  { lead_property_details,
    setSuccessMsg,
    setError,
    getLeadList,
    setAcceptedProperty,
    acceptedProperty }: any) => {
  const [scheduleVisit, setScheduleVisit] = useState<string | null>(null)
  const [saveFeedback, setSaveFeedback] = useState<string | null>(null)
  // function to color the status based on the status code
  const returnStatusColor = (val: number) => {
    switch (val) {
      // for Added
      case 0:
        return 'badge-light-primary'
      // for Accepted
      case 1:
        return 'badge-light-success'
      // for Scheduled
      case 2:
        return 'badge-light-info'
      // for Visited
      case 3:
        return 'badge-light-warning'
      // for Rejected
      case 4:
        return 'badge-light-danger'
      // for deleted
      case 5:
        return 'badge-light-dark'
      // // Details submitted
      // case 6:
      //   return `${styles.status_processing}`
      // // Booking amount paid
      // case 7:
      //   return `${styles.status_payment_done}`
      default:
        return 'badge-light-primary'
    }
  }
  const deleteProperty = async (leads_property_uuid: any) => {
    // Swal.fire({
    //   title: 'Are you sure that you want to delete property',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes',
    // }).then(async (result: any) => {
    //   if (result.isConfirmed) {
        try {
          const { data: response } = await leadPropertyStatus(
            leads_property_uuid,
            5,
            ""
          )
          if (response.code === '200') {
            getLeadList()
            setSaveFeedback(null)
            setSuccessMsg(`Success: Property Deleted Successfully!`)
          } else {
            setError(`Error: ${response.msg_details}`)
          }
        } catch (error: any) {
          setError(`Error: ${error}`)
        }
    //   }
    // })
  }
  return (
    <div data-kt-stepper-element='content'>
      <div className='w-100'>
        <h4 className='text-primary'>Property Table</h4>
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            {lead_property_details?.length > 0 && (
              <thead>
                <tr className='fw-bold text-muted'>
                  <th className='max-w-200px'>Property Name</th>
                  <th className='max-w-200px'>Date of Visit</th>
                  <th className='max-w-150px'>Customers feedback</th>
                  <th className='max-w-100px'>Status</th>
                  <th className='max-w-100px'>Actions</th>
                  {/* {typeOfModal !== 'Visited' && <th className='max-w-100px'>Actions</th>} */}
                </tr>
              </thead>
            )}
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {
                lead_property_details?.length > 0 ?
                  lead_property_details?.map((property: any) => (
                    <>
                      <tr>
                        <td className='max-w-200px'>
                          <Link
                            to={`/property/${property.property_uuid}/overview`}
                            target='_blank'
                            className='text-muted fw-semibold text-muted d-block fs-7'
                          >
                            {property.property_title}
                          </Link>
                        </td>
                        <td className='max-w-200px'>
                          <span className='text-dark fw-bold text-hover-primary d-block fs-6 cursor-pointer'>
                            {property.scheduled_visit_date
                              ? new Date(
                                property.scheduled_visit_date
                              ).toLocaleString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                              })
                              : '-'}
                          </span>
                        </td>
                        <td className='max-w-200px'>
                          <span className='text-dark fw-bold text-hover-primary d-block fs-6 cursor-pointer'>
                            {property.customer_feedback
                              ? property.customer_feedback
                              : '-'}

                          </span>
                        </td>
                        <td className='max-w-150px'>
                          <span
                            className={`badge fw-semibold fs-7
                    ${returnStatusColor(
                              property.leads_property_status
                            )} `}
                          >
                            {property.leads_property_status_msg}
                          </span>
                        </td>
                        <td>
                          {
                            property.leads_property_status !== 1 && acceptedProperty?.length > 0 ?
                              null
                              :
                              <>
                                {
                                  (property.leads_property_status !== 1 && property.leads_property_status !== 4) &&
                                  <button
                                    className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                    onClick={() => {
                                      setSaveFeedback(null)
                                      setScheduleVisit(property.leads_property_uuid)
                                      // setAddBookingAmt(null)
                                    }}
                                  >
                                    <i
                                      className='bi bi-calendar2-event fs-3'
                                      title='Schedule a Visit'
                                    ></i>
                                  </button>
                                }
                                <button
                                  className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                  onClick={() => {
                                    setScheduleVisit(null)
                                    setSaveFeedback(property.leads_property_uuid)
                                    // setAddBookingAmt(null)
                                  }}
                                >
                                  <i
                                    className='bi bi-emoji-smile-fill fs-3'
                                    title='Customer Feedback'
                                  ></i>
                                </button>
                              </>

                          }
                          <button
                            className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            onClick={() =>
                              deleteProperty(property.leads_property_uuid)
                            }
                          >
                            <i
                              className='bi bi-trash-fill bi-4x fs-3'
                              title='Delete Property'
                            ></i>
                          </button>
                        </td>
                        {/* {typeOfModal !== 'Visited' && (
                                        <td className='max-w-100px'>
                                          <div className='d-flex flex-shrink-0'>
                                            {typeOfModal === 'Matched' &&
                                              !property.customer_feedback &&
                                              property.leads_property_status !== 1 &&
                                              property.leads_property_status !== 3 &&
                                              property.leads_property_status !== 4 && (
                                                <button
                                                  className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                  onClick={() => {
                                                    setSaveFeedback(null)
                                                    setScheduleVisit(property.leads_property_uuid)
                                                    setAddBookingAmt(null)
                                                  }}
                                                >
                                                  <i
                                                    className='bi bi-calendar2-event fs-3'
                                                    title='Schedule a Visit'
                                                  ></i>
                                                </button>
                                              )}
                                            {result.length <= 0 && (
                                              <button
                                                className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                onClick={() => {
                                                  setScheduleVisit(null)
                                                  setSaveFeedback(property.leads_property_uuid)
                                                  setAddBookingAmt(null)
                                                }}
                                              >
                                                <i
                                                  className='bi bi-emoji-smile-fill fs-3'
                                                  title='Customer Feedback'
                                                ></i>
                                              </button>
                                            )}
                                            {typeOfModal === 'Matched' &&
                                              property.leads_property_status === 1 && (
                                                <>
                                                  {property.lead_booking_details
                                                    .lead_property_booking_json ? (
                                                    <button
                                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                      onClick={() => {
                                                        setScheduleVisit(null)
                                                        setSaveFeedback(null)
                                                        setAddBookingAmt(
                                                          property.leads_property_uuid
                                                        )
                                                      }}
                                                    >
                                                      <i
                                                        className='bi bi-cash-stack fs-3'
                                                        title='Add booking amount'
                                                      ></i>
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                      onClick={() => {
                                                        handleGenerateLeadFormID(
                                                          property.leads_property_uuid
                                                        )
                                                      }}
                                                    >
                                                      <i
                                                        className='bi bi-check2-square fs-3'
                                                        title='Confirm booking'
                                                      ></i>
                                                    </button>
                                                  )}
                                                </>
                                              )}
                                          </div>
                                        </td>
                                      )} */}
                      </tr>
                      {scheduleVisit === property.leads_property_uuid && (
                        <ScheduleVisit
                          setSaveFeedback={setSaveFeedback}
                          setScheduleVisit={setScheduleVisit}
                          leads_property_uuid={property.leads_property_uuid}
                          getLeadList={getLeadList}
                          scheduled_visit_date={property.scheduled_visit_date}
                          setSuccessMsg={setSuccessMsg}
                          setError={setError}
                        />
                      )}
                      {saveFeedback === property.leads_property_uuid && (
                        <SaveFeedback
                          setSaveFeedback={setSaveFeedback}
                          setScheduleVisit={setScheduleVisit}
                          leads_property_uuid={property.leads_property_uuid}
                          getLeadList={getLeadList}
                          returnStatusColor={returnStatusColor}
                          customer_feedback={property.customer_feedback}
                          leads_property_status={property.leads_property_status}
                          setSuccessMsg={setSuccessMsg}
                          setError={setError}
                          setAcceptedProperty={setAcceptedProperty}
                        />
                      )}
                    </>))
                  :
                  <tr>
                    <td colSpan={5}>
                      <span className='d-flex flex-column align-items-center flex-start px-10'>
                        <img
                          src='/media/svg/undraw/property.svg'
                          alt='No document uploaded'
                          className='h-200px w-200px'
                        />
                        <span className='fw-bold text-muted fs-1 text-center'>
                          No properties added for lead
                        </span>
                      </span>
                    </td>
                  </tr>
              }</tbody>

            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
      </div>
    </div>
  )
}

export default ViewLeadStep2
